import loungwear from "./images/loungewear.jpg";
import jacket from "./images/jacket.jpg";
import dress from "./images/dress.jpg";

export const categories = [
  {
    id: 1,
    img: dress,
    title: "Dresses",
    cat: "dresses"
  },
  {
    id: 2,
    img: loungwear,
    title: "Loungewear love",
    cat: "loungewear"
  },
  {
    id: 3,
    img: jacket,
    title: "Light Jackets",
    cat: "jackets"
  },
];
